import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../../services/auth.service";
import { Router } from '@angular/router';
import { TravelService } from 'src/app/services/travel.service';
import { validateConfig } from '@angular/router/src/config';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  public name = "";

  //notificaciones
  public actCatalogos:boolean = true;
  public actUser:boolean = true;
  public actAuthRoleAb:boolean = true;
  public actAssignRoleAb:boolean = true;
  public actAuth:boolean = true;
  public actCust:boolean = true;
  public actProv:boolean = true;
  public actUni:boolean = true;
  public actUniGroup:boolean = true;
  public actUniService:boolean = true;
  public actUniContrator:boolean = true;
  public actProd:boolean = true;
  public actArt:boolean = true;
  public actDriv:boolean = true;
  public actExp:boolean = true;

  public actSells:boolean = true;
  public actOrd:boolean = true;
  public actCalendar: boolean = true;
  public actLoadsCalendar: boolean = true;
  public actStoreOrd:boolean = true;

  public actLogistic:boolean = true;
  public actRoute:boolean = true;
  public actStoreRoute: boolean = true;
  public actTravel:boolean = true;
  public actContractedTravel:boolean = true;
  public actEmmitGas:boolean = true;
  public actStoreTravel: boolean = true;
  public actStoreTravelParticular: boolean = true;
  public actUpdateTollBooth:boolean = true;

  public actMaintenance: boolean = true;
  public actMainOrd: boolean = true;
  public actStoreMainOrd: boolean = true;
  public actMainExp: boolean = true;
  public actStoreMainExp: boolean = true;
  public actUtilitarianControl: boolean = true;
  public actUniVerification: boolean = true;
  public actUniServiceCalendar: boolean = true;
  
  public actRh:boolean = true;
  public actStorePayExp:boolean = true;
  public actPaysheet:boolean = true;
  public actPaysheetBase:boolean = true;
  
  public actFinancial:boolean = true;
  public actMarketPrice:boolean = true;
  public actStoreExtraExp:boolean = true;
  public actStoreExtraExpJob:boolean = true;

  public actPurchases:boolean = true;
  public actRequisition:boolean = true;
  public actStoreRequisition:boolean = true;
  public actPurchaseOrder:boolean = true;
  public actStorePurchaseOrder:boolean = true;
  public actPurchaseOrderReport:boolean = true;
  public actNotDoc:boolean = true;
  public actPurchaseOrderSapReport:boolean = true;
  public actEntrySapReport:boolean = true;

  public actInventory:boolean = true;
  public actEntry:boolean = true;
  public actStoreEntry:boolean = true;
  public actWarehouse:boolean = true;
  public actEntryReport:boolean = true;

  public actReports:boolean = true;
  public actGasReport:boolean = true;
  public actExtraExpenseReport:boolean = true;
  public actMaintenanceReport:boolean = true;
  public actKmReport:boolean = true;
  public actPaysheetReport:boolean = true;
  public actUniReport:boolean = true;
  public actUniReport2:boolean = true;
  public actProecoReport:boolean = true;
  public actDashboard:boolean = true;
  public actDashboardMain:boolean = true;
  public actExpensesReport:boolean = true;
  public actBinnacleReport:boolean = true;
  public actUniServicesReport:boolean = true;
  public actInternalTravelInvoice: boolean = true;
  public actInvoiceTickets: boolean = true;
  //Soporte Christian Gonzalez
  public actSupport: boolean = true;
  //Permiso Especial Sulem (Solo Bitacora Fletes)
  public actSulemSpecPerm: boolean = true;
  //Permiso Rutas viajes (Cambiar Precio Mercado)
  public actPrecioMercadoViajes: boolean = true;
  //Quitar Permiso Ordenes de Compra
  public actQuitarPermisoOrdenCompra: boolean = false;

  constructor(private authService : AuthService, private router: Router, private travelServ:TravelService, private toastr:ToastrManager) { }

  ngOnInit() {
    let actUser = this.authService.getActualUser();
    this.name = actUser ? actUser.name : "";

    if(actUser) {
      this.actUser = this.authService.can("get-users");
      this.actAuth = this.authService.can("authorization");
      this.actAuthRoleAb = this.authService.can("authorization");
      this.actAssignRoleAb = this.authService.can("authorization");
      this.actCust = this.authService.can("get-customers");
      this.actProv = this.authService.can("get-suppliers");
      this.actUni = this.authService.can("get-unities");
      this.actUniGroup = this.authService.can("get-unities") && (this.authService.isNot("machinery") && this.authService.isNot("staff"));
      this.actUniService = this.authService.can("unit-service-admin");
      this.actUniContrator = this.authService.can("get-unities");
      this.actProd = this.authService.can("get-products");
      this.actArt = this.authService.can("get-articles");
      this.actDriv = this.authService.can("get-drivers");
      this.actExp = this.authService.can('get-expenses');
      this.actCatalogos = this.actUser || this.actAuth || this.actAssignRoleAb || this.actAuthRoleAb || this.actCust || this.actProv || this.actUni || this.actUniGroup || this.actUniService || this.actUniContrator || this.actProd || this.actArt || this.actDriv || this.actExp;

      this.actOrd = this.authService.can("get-orders");
      this.actStoreOrd = this.authService.can("store-order");
      this.actCalendar = this.authService.can("get-orders");
      this.actLoadsCalendar = this.authService.can("get-loads-orders");
      this.actSells = this.actOrd || this.actStoreOrd || this.actCalendar || this.actLoadsCalendar;

      this.actRoute = this.authService.can('get-routes');
      this.actStoreRoute = this.authService.can("store-route");
      this.actTravel = this.authService.can('get-travels');
      this.actContractedTravel = this.authService.can('store-contracted-invoice');
      this.actStoreTravel = this.authService.can("store-travel");
      this.actStoreTravelParticular = this.authService.can("store-travel-part");
      this.actEmmitGas = this.authService.can("emmit-gas");
      this.actUpdateTollBooth = this.authService.can("update-tollbooth");
      this.actLogistic = this.actRoute || this.actStoreRoute || this.actTravel || this.actStoreTravel || this.actEmmitGas || this.actContractedTravel || this.actUpdateTollBooth || this.actStoreTravelParticular;

      this.actMainOrd = this.authService.can("get-maintenance-orders");
      this.actStoreMainOrd = this.authService.can("store-maintenance-order");
      this.actMainExp = this.authService.can("get-maintenances");
      this.actStoreMainExp = this.authService.can("store-maintenance");
      this.actUtilitarianControl = this.authService.can("unit-service");
      this.actUniVerification = this.authService.can("unit-verification");
      this.actUniServiceCalendar = this.authService.can("unit-service-calendar");
      this.actMaintenance = this.actMainOrd || this.actStoreMainOrd || this.actStoreMainExp || this.actUtilitarianControl || this.actUniVerification || this.actUniServiceCalendar;

      this.actStorePayExp = this.authService.can("store-paysheet-expenses");
      this.actPaysheet = this.authService.can("get-paysheets");
      this.actPaysheetBase = this.authService.can("get-paysheets");
      this.actRh = this.actStorePayExp || this.actPaysheet || this.actPaysheetBase ;

      this.actStoreExtraExp = this.authService.can("store-extra-expense");
      this.actStoreExtraExpJob = this.authService.can("get-extra-expenses-job");
      this.actMarketPrice = this.authService.can("get-market-prices");
      this.actFinancial = this.actStoreExtraExp || this.actMarketPrice || this.actStoreExtraExpJob;

      this.actRequisition = this.authService.can("get-requisitions");
      this.actStoreRequisition = this.authService.can("store-requisition");
      this.actPurchaseOrder = this.authService.can("get-purchase-orders");
      this.actStorePurchaseOrder = this.authService.can("store-purchase-order");
      this.actPurchaseOrderReport = this.authService.can("get-report-purchase-orders");
      this.actNotDoc = this.authService.can("get-document-notifications");
      this.actPurchaseOrderSapReport = this.authService.can("get-report-purchase-orders");
      this.actEntrySapReport = this.authService.can("get-report-entries");
      this.actPurchases = this.actRequisition || this.actStoreRequisition || this.actPurchaseOrder || this.actStorePurchaseOrder || this.actPurchaseOrderSapReport || this.actEntrySapReport;
      
      this.actEntry = this.authService.can("get-entries");
      this.actStoreEntry = this.authService.can("store-entry");
      this.actWarehouse = this.authService.can("get-warehouses");
      this.actEntryReport = this.authService.can("get-report-entries");
      this.actInventory = this.actEntry || this.actStoreEntry || this.actWarehouse || this.actEntryReport;

      this.actGasReport = this.authService.can("get-report-gas");
      this.actMaintenanceReport = this.authService.can("get-report-maintenance");
      this.actKmReport = this.authService.can("get-report-unity-km");
      this.actExtraExpenseReport = this.authService.can("get-report-extra-expense");
      this.actPaysheetReport = this.authService.can("get-report-paysheet");
      this.actExpensesReport = this.authService.can("get-report-total-expenses");
      this.actUniReport = this.authService.can("get-report-unities");
      this.actUniReport2 = this.authService.can("get-report-unities");
      this.actProecoReport = this.authService.can("get-report-proeco");
      this.actDashboard = this.authService.can("get-report-total-expenses");
      this.actDashboardMain = this.authService.can("get-report-maintenance");
      this.actBinnacleReport = this.authService.can("get-report-binnacle");
      this.actUniServicesReport = this.authService.can("unit-service-admin");
      this.actReports = this.actGasReport || this.actMaintenanceReport || this.actExtraExpenseReport || this.actPaysheetReport || this.actExpensesReport || this.actProecoReport || this.actDashboard || this.actDashboardMain || this.actUniReport || this.actKmReport || this.actUniReport2 || this.actUniServicesReport;

      this.actInvoiceTickets = this.authService.can('upload-invoice-data');

      this.actInternalTravelInvoice = this.authService.can('store-commercial-documents-internal-travel');

      this.actSupport = this.authService.can('platform-support');

      this.actSulemSpecPerm = this.authService.can('sulem-special-permission'); //Permiso Especial Sulem

      this.actPrecioMercadoViajes = this.authService.can('price-market-travels'); //Actualizar Precio Mercado

      this.actQuitarPermisoOrdenCompra = this.authService.can('quitar-permiso-orden-compras-especial') && !this.authService.can("*") ? true : false;
    }
  }

  logout() {
    this.authService.logout();
  }

  showTravel(event) {
    event.preventDefault();
    var id = event.target.querySelector('#trId').value;

    this.router.navigate(['/travels', id]);
  }

  showOrder(event) {
    event.preventDefault();
    var id = event.target.querySelector('#orId').value;

    this.router.navigate(['/order', id]);
  }

  showReq(event) {
    event.preventDefault();
    var id = event.target.querySelector('#reId').value;

    this.router.navigate(['/purchases/requisition', id]);
  }

  showPurOrd(event) {
    event.preventDefault();
    var id = event.target.querySelector('#poId').value;

    this.router.navigate(['/purchases/order', id]);
  }

  showEntry(event) {
    event.preventDefault();
    var id = event.target.querySelector('#enId').value;

    this.router.navigate(['/purchases/entry', id]);
  }

  showOCWalmart(event) {
    event.preventDefault();
    var id = event.target.querySelector('#ocWal').value;

    this.travelServ.transformWMtoTravel(id).then(id => {
      id == 0 ? this.toastr.infoToastr("No se ha creado ningún viaje con esa orden de compra") : this.router.navigate(['/travels', id]);
    });
  }

  showANWalmart(event) {
    event.preventDefault();
    var id = event.target.querySelector('#anWal').value;

    this.travelServ.transformANtoTravel(id).then(id => {
      id == 0 ? this.toastr.infoToastr("No se ha creado ningún viaje con este numero de cita") : this.router.navigate(['/travels', id]);
    });
  }

}
